<app-modal>
    <div modal-header>
        <span i18n="@@chooseRegistration.modal.title">Closed Beta</span>
    </div>
    <div modal-body>
        <div class="chooseRegistration">
            <div class="explanation">
                We are currently in Closed Beta, which means you will need a beta-key to join the game. If you already received your beta-key, you can proceed to the registration. If you do not have your beta-key yet, you can still apply for one. We will send out new invitations on a regular basis!
            </div>
            <div class="questionContainer text-center">
                <h5>Beta Key?</h5>
                <div class="selectOptionsContainer">
                    <div class="boxContainer" [routerLink]="['', {outlets: { modal: ['preregister']}}]" skipLocationChange>
                        <div class="icon">
                            <i class="ic_key_needed"></i>
                        </div>
                        <div class="name">I need a key!</div>
                    </div>
                    <div class="boxContainer jqFenster" data-mellon-iframe-url="/registration/index" data-selector="#mellonModal">
                        <div class="icon">
                            <i class="ic_key_owned"></i>
                        </div>
                        <div class="name">I have a key!</div>
                    </div>
                </div>
            </div>

            <div class="text-center">
                <label i18n="@@chooseRegistration.modal.alreadyRegistered">You got already an account? </label>
                &nbsp; <a class="jqFenster" href="#" data-mellon-iframe-url="/authentication/login" data-selector="#mellonModal" i18n="Opens Login Modal@@register.modal.link.login">Log in here</a>
            </div>
        </div>
    </div>
</app-modal>
